module.exports = __webpack_public_path__ + "img/hotel.be5030ca.webp";